import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ForgotPasswordRequest } from '../../models/forgot-password.model';
import { PasswordResetRecord, ResetPasswordRequest } from '../../models/reset-password.model';
import { Observable } from 'rxjs/internal/Observable';
import {
  getPasswordForgotUrl,
  getPasswordResetUrl,
  getPasswordTokenUrl,
  getPasswordChangeUrl,
} from '../../shared/utils/api-urls.utils';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  /**
   * Constructor to initialize the service
   */
  constructor(private readonly _http: HttpClient) {}

  /**
   * Send forgot password request to the API
   * @param email User's email address
   * @param ssnLast4 Last 4 digits of SSN
   * @returns Observable of the response
   */
  sendForgotPasswordRequest(email: string, ssnLast4: string, dateOfBirth: string): Observable<any> {
    // Create request body
    const body: ForgotPasswordRequest = {
      email,
      ssnLast4,
      dateOfBirth,
    };
    return this._http.post<any>(getPasswordForgotUrl(), body);
  }

  /**
   * Fetch password reset token
   * @param token Reset token from URL
   * @returns Observable of password reset record
   */
  fetchResetToken(token: string): Observable<PasswordResetRecord> {
    return this._http.get<PasswordResetRecord>(getPasswordTokenUrl(token));
  }

  /**
   * Reset password using token and new password
   * @param token Reset token
   * @param newPassword New password
   * @returns Observable of the response
   */
  resetPassword(token: string, newPassword: string): Observable<any> {
    const request: ResetPasswordRequest = {
      token,
      newPassword,
    };
    return this._http.post<any>(getPasswordResetUrl(), request);
  }

  changePassword(currentPassword: string, newPassword: string) {
  const body: ChangePasswordRequest = { currentPassword, newPassword };
  return this._http.post<any>(getPasswordChangeUrl(), body);
}
}
